import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { Observable } from 'rxjs/internal/Observable';
import { cacheable } from '@app/utils/rxjs-functions';

import { ExpiringCache, MaterialCategory } from '@app/models';
import { SharedUtilsService } from '../shared-utils.service';

export interface MaterialCategoryApi {
    items: MaterialCategory[];
    total_count: number;
}

@Injectable({
    providedIn: 'root'
})
export class MaterialCategoryService {
    private _categoryRoute = '/api/material-categories/';
    private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    categoriesStorage: ExpiringCache = new ExpiringCache();
    public selectedCategory: any = {};

    constructor(
        private httpClient: HttpClient,
        private _sharedUtilsService: SharedUtilsService,
        private formBuilder: UntypedFormBuilder
    ) { }


    setCategoryToBeViewed(category: any) {
        this.selectedCategory = category;
    }

    getCategoryToBeViewed() {
        return this.selectedCategory;
    }


    getMaterialCategories(): Observable<MaterialCategory[]> {
        // smarter than just going to api every time. Getting them all, so just cache for use in dropdowns all over
        if (this._sharedUtilsService.isStorageValid(this.categoriesStorage)) {
            return this.categoriesStorage.itemCache;
        }

        this.categoriesStorage = this._sharedUtilsService.updateStorageExpiration(this.categoriesStorage);
        return this.categoriesStorage.itemCache = cacheable<any>(this.httpClient.get<MaterialCategory[]>(this._categoryRoute));
    }


    get(_id: any): Observable<MaterialCategory> {
        return this.httpClient.get<MaterialCategory>(this._categoryRoute + _id);
    }


    create(_category: MaterialCategory): Observable<MaterialCategory> {
        return this.httpClient.post<MaterialCategory>(this._categoryRoute, JSON.stringify(_category), this.headerOptions);
    }


    getCustomDatasource(searchParams, sortField = 'name', sortDirection = 'asc', pageNumber: number = 0, pageSize: number = 10): Observable<MaterialCategoryApi> {
        searchParams['selectAll'] = false;
        searchParams.sortField = sortField;
        searchParams.sortOrder = (sortDirection && sortDirection !== '') ? sortDirection : 'asc';
        searchParams.pageNumber = pageNumber;
        searchParams.pageSize = pageSize;

        return this.httpClient.post<MaterialCategoryApi>(this._categoryRoute + 'dataSourceSearch', JSON.stringify(searchParams), this.headerOptions);
    }


    selectAllSearch(searchTerms): Observable<any> {
        searchTerms['selectAll'] = true;
        return this.httpClient.post<any>(this._categoryRoute + 'dataSourceSearch', JSON.stringify(searchTerms), this.headerOptions);
    }


    update(_category: MaterialCategory): Observable<MaterialCategory> {
        return this.httpClient.put<MaterialCategory>(this._categoryRoute + _category._id, JSON.stringify(_category), this.headerOptions);
    }


    delete(_category: MaterialCategory): Observable<any> {
        return this.httpClient.delete(this._categoryRoute + _category._id, this.headerOptions);
    }


    deleteCategoriesByIdArray(arrayOfIds): Observable<any> {
        return this.httpClient.post<any>(this._categoryRoute + 'deleteMany', JSON.stringify(arrayOfIds), this.headerOptions);
    }


    categoryFormGroup(formData: MaterialCategory) {
        return this.formBuilder.group({
            name: [formData.name, Validators.required],
            subCategories: [formData.subCategories]
        });
    }
}